import React from 'react'
import { Button } from 'components/base'

import Modal from 'react-modal'
import { MODAL_DEFAULT_STYLE } from './style'

export default function PasswordModal({
  cancelLabel,
  confirmLabel,
  CancelButtonComponent = Button.Secondary,
  ConfirmButtonComponent = Button.Danger,
  onConfirm,
  onCancel,
  children,
  show,
}) {
  const style = {
    content: {
      ...MODAL_DEFAULT_STYLE.content,
      width: 400,
      zIndex: 10,
    },
    overlay: {
      ...MODAL_DEFAULT_STYLE.overlay,
      zIndex: 9,
    },
  }
  return (
    <Modal
      style={style}
      isOpen={show}
      className="modal-alert background-shade-100"
      onRequestClose={onCancel}
    >
      <div className="padding-larger center-text">
        <div className="line-height-large">{children}</div>
        <div className="flexbox margin-top-large width-half">
          <CancelButtonComponent className="flexbox-grow" onClick={onCancel}>
            {cancelLabel}
          </CancelButtonComponent>
          <div className="margin-left-large" />
          <Button.Primary
            className="flexbox-grow"
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </Button.Primary>
        </div>
      </div>
    </Modal>
  )
}
